import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { objectToSnake } from 'ts-case-convert';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';

@Injectable({
  providedIn: 'root',
})
export class VehiclesHttpService extends BaseHttpService {
  private baseURL = `vehicles`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getSetupVehicles(routeId: number) {
    const path = `/service/${routeId}`;
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.read(url);
  }

  public filterVehicles(
    page: number = 1,
    size: number = 10,
    clientsSelected: number[],
    operatorsSelected: number[],
    active?: boolean,
    searchValue?: string
  ) {
    let path = `/filter?page=${page}&size=${size}`;
    if (clientsSelected && clientsSelected.length > 0) path += `&clients=${clientsSelected.join(',')}`;
    if (operatorsSelected && operatorsSelected.length > 0) path += `&operators=${operatorsSelected.join(',')}`;
    if (active !== undefined) path += `&active=${active}`;
    if (searchValue) path += `&search=${encodeURIComponent(searchValue)}`;
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.read(url);
  }

  public getVehicles(clientId?: number) {
    const path = clientId != null ? `?client_id=${clientId}` : '';
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.read(url);
  }

  public createVehicle(payload: IVehiclePayload) {
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.create(objectToSnake(payload), url);
  }

  public updateVehicle(vehicleId: number, payload: IVehiclePayload) {
    const url = this.routerService.mount(`${this.baseURL}/${vehicleId}`);
    return this.update(objectToSnake(payload), url);
  }
}

export interface IVehiclePayload {
  name?: string;
  availableSeats?: number;
  active?: boolean;
  length?: number;
  operatorId?: number;
  convertibleSeats?: { numberOfRegularSeats: number }[];
}
